export function print(blob: Blob) {
    const iframe = document.createElement('iframe');
    document.body.appendChild(iframe);

    iframe.src = URL.createObjectURL(blob);
    iframe.style.display = 'none';

    const removeFrame = () => {
        iframe.remove();
        window.removeEventListener('focus', removeFrame);
    };

    window.addEventListener('focus', removeFrame);

    iframe.onload = function () {
        setTimeout(function () {
            if (iframe.contentWindow) {
                iframe.focus(); // Required for IE
                iframe.contentWindow.print();
            }
        }, 0);
    };
}

export function load(blob: Blob, name: string) {
    const link = document.createElement('a');
    link.download = name;

    link.href = URL.createObjectURL(blob);

    link.click();

    URL.revokeObjectURL(link.href);
}
